import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';

import { AppStyles, AppTheme } from '../styles/AppTheme';
import { UiHelper } from '../common/helpers/UiHelper';
import SelectTemplate from './SelectTemplate';
import LayoutEditor from './LayoutEditor';
import { Helper } from '../common/helpers/Helper';
import { AppButton } from '../common/components/AppButton';
// import { GridLayout } from 'react-grid-layout';
export class LayoutCreationDialog extends Component {
  constructor(props) {
    super(props)
    const groupId = props.orgId
    if (props.layoutJson) {
      this.state = {
        template: props.layoutJson,
        templateSelected: true,
        groupId
      }
    } else {
      this.state = {
        templateSelected: false,
        template: null,
        groupId
      }
    }
  }

  // componentDidUpdate(prevProps) {
  //   if (this.state.template !== this.props.layoutJson) {
  //     if (this.props.layoutJson) {
  //       this.setState({
  //         template: this.props.layoutJson,
  //         templateSelected: true,
  //       });
  //     }
  //   }
  // }

  onCloseModal() {
    this.props.onClosed()
    this.setState({
      templateSelected: false,
      template: null,
    })
  }

  handleOnSelectTemplate = (template) => {
    console.log('selected', template);
    this.setState({
      template: {...template, layoutName:''},
      templateSelected: true,
    });
  };

  _getLayoutSizeString(layout) {
    if(layout.width && layout.height) {
      return `(${layout.width} X ${layout.height})`
    }
    return ''
  }

  render() {
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.state.templateSelected ? Helper.getString('templateSetting') : Helper.getString('newLayout')}
        fullWidth={false}
        maxWidth='lg'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.state.templateSelected ? Helper.getString('templateSetting') + ' ' + this._getLayoutSizeString(this.state.template) : Helper.getString('newLayout')}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          {!this.state.templateSelected && <SelectTemplate onSelectTemplate={this.handleOnSelectTemplate} />}
          {this.state.templateSelected && <LayoutEditor {...this.props} orgId={this.state.groupId} layoutJson={this.state.template || null}  />}
        </div>
      </Dialog>
    );
  }
}

const Styles = StyleSheet.create({
  inputsHolder: {
    minWidth: 800,
    minHeight: 400,
    display: 'flex',
    padding: '10px 20px',
    gap: 20
  },
  inputs: {
    flex: 1
  },
  fieldLabel: {
    fontSize: 14,
    color: 'rgb(18, 18, 18)',
    margin: '0px 0px 8px',
  },
  field: {
    padding: '10px 20px',
    flex: '1 1 0%',
    textAlign: 'left',
    fontSize: '16px',
    color: '#000',
    background: 'rgb(217, 217, 217)',
    borderRadius: 8,
    minHeight: 20
  },
  modalHeader: {
    padding: '18px 21px 14px'
  },
  modalTitle: {
    maxWidth: 180,
    whiteSpace: 'nowrap',
    color: 'black',
    fontSize: 28,
    fontWeight: '600 !important'

  },
  modalContent: {
    // maxWidth: 400,
    minWidth: 200,
    // minHeight: 420,
    padding: 28,
    paddingTop: 10
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: 'black',
    borderRadius: AppTheme.borderRadius
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius
  },
})



// WEBPACK FOOTER //
// ./src/components/LayoutCreationDialog.js